<template>
    <v-app>
        <div
            v-if="$route.name === 'InfoPage'"
            style="background-color: #fff; margin: 0; padding: 0"
        >
            <app-info-page v-if="!$store.state.auth.loggedIn"></app-info-page>
        </div>
        <div id="app" v-if="$route.name !== 'InfoPage'">
            <the-navigation-drawer
                v-if="$store.state.auth.loggedIn"
            ></the-navigation-drawer>

            <the-toolbar v-if="$store.state.auth.loggedIn"></the-toolbar>

            <app-alert></app-alert>

            <v-main style="background-color: #f3f5f7; padding-bottom: 20px">
                <v-container fluid>
                    <!-- <transition name="fade-transition" mode="out-in"> -->
                    <router-view></router-view>
                    <!-- </transition> -->
                </v-container>
            </v-main>

            <!-- <app-footer v-if="$store.state.auth.loggedIn"></app-footer> -->

            <a
                href="javascript:;"
                class="btn btn-icon btn-circle btn-success btn-scroll-to-top fade"
                data-click="scroll-top"
                style="background-color: #2690cb !important"
            >
                <i class="fa fa-angle-up"></i>
            </a>
        </div>
    </v-app>
</template>

<script>
import Alert from "@/modules/global/components/layout/Alert";
import auth from "@/modules/auth/services/auth.js";
import Footer from "@/modules/global/components/layout/Footer";
import Header from "@/modules/global/components/layout/Header";
import InfoPage from "@/modules/ambis_meter/components/InfoPage";
import Login from "@/modules/auth/components/Login";
import Sidebar from "@/modules/global/components/layout/Sidebar";
import TheNavigationDrawer from "@/modules/global/components/layout/TheNavigationDrawer";
import TheToolbar from "@/modules/global/components/layout/TheToolbar";

export default {
    name: "app",

    components: {
        "app-alert": Alert,
        "app-footer": Footer,
        "app-header": Header,
        "app-info-page": InfoPage,
        "app-login": Login,
        "app-sidebar": Sidebar,
        TheNavigationDrawer,
        TheToolbar,
    },

    watch: {
        "$store.state.auth.loggedIn": function (loggedIn) {
            if (!loggedIn) {
                if (this.$route.name === "InfoPage") {
                    this.$router.push("/info-page");
                } else {
                    this.$router.push("/login");
                }
            } else if (this.$route.name === "Login") {
                // Validasi token selesai setelah halaman Login ter-mount
                this.$router.push("/");
            }
        },

        $route(to, from) {
            document.title = "Skolla Admin";
            this.$store.commit("datatable_page_before", from.name);
        },
    },

    mounted: function () {
        var context = this;

        this.$ls.on("logged_in", function (loggedIn) {
            if (!loggedIn) {
                context.$store.commit("auth_destroyed");
            }
        });

        if (!this.$ls.get("logged_in")) {
            if (this.$route.name === "InfoPage") {
                this.$router.push("/info-page");
            } else {
                this.$router.push("/login");
            }
            // this.$router.push("/login");
        } else {
            var token = JSON.parse(localStorage.token).value;
            auth.doValidateToken(token, function (validateTokenResult) {
                if (!validateTokenResult.success) {
                    if (context.$route.name === "InfoPage") {
                        context.$router.push("/info-page");
                    } else if (context.$route.name !== "Login") {
                        context.$router.push("/login");
                    }
                    return;
                }

                context.$store.commit(
                    "auth_authenticated",
                    validateTokenResult.scopes
                );
            });
        }
    },
};
</script>



// WEBPACK FOOTER //
// App.vue?0ffe310e